import { render, staticRenderFns } from "./MailAccountCallback.vue?vue&type=template&id=2c3771c1&"
import script from "./MailAccountCallback.vue?vue&type=script&lang=js&"
export * from "./MailAccountCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports